const angular = require('angular')
require('./header.scss')
module.exports = angular
  .module('mw.header', [
    require('./header.directive'),
  ]).name
